import { Container } from './styled'

const CardHowItWork = ({title, description, image}) => {

    return (
        <Container>
            <div className="div-text-card-tutorial">
                <span>{title}</span>
                <ul>
                    {description.map((element, id) => (
                        <li key={id}>{element}</li>
                    ))}
                </ul>
            </div>
            <img src={image} alt="Imagem tutorial" />

        </Container>
    )
}

export default CardHowItWork
